import { createContext } from "react";


export const UserContext = createContext<{user:any;setUser:any;userCalled:boolean,isAdmin:boolean,userName:string|null, adminLevel?:Number}|null>(null);